// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Toggletip-components-ToggletipArrow-ToggletipArrow-module__arrow";
var _2 = "webpack-components-core-Toggletip-components-ToggletipArrow-ToggletipArrow-module__dark";
export { _1 as "arrow", _2 as "dark" }
